import { render, staticRenderFns } from "./ConfirmDeliver.vue?vue&type=template&id=5b0782c4&scoped=true&lang=pug&"
import script from "./ConfirmDeliver.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeliver.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeliver.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConfirmDeliver.vue?vue&type=style&index=1&id=5b0782c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0782c4",
  null
  
)

export default component.exports